'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _toggleClass = require('helpers/toggleClass');

var _toggleClass2 = _interopRequireDefault(_toggleClass);

var _Modal2 = require('./Modal');

var _Modal3 = _interopRequireDefault(_Modal2);

require('./EnterpriseModal.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This keeps track of how many modals that are open so that the
// container class and container padding for the scrollbar is correctly set.
var numberOfModalsOpen = 0;

var KEY_CODES = {
  ESCAPE: 27,
  ENTER: 13
};

// TODO: Try to use composition (HOC) instead inheritance
var EnterpriseModal = (_temp2 = _class = function (_Modal) {
  (0, _inherits3.default)(EnterpriseModal, _Modal);

  function EnterpriseModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EnterpriseModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnterpriseModal.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleKeys = function (e) {
      // Handle escape press
      if (e.which === KEY_CODES.ESCAPE) {
        _this.onCancel(e, true);
      } else if (e.which === KEY_CODES.ENTER) {
        // Don't do anything while animating
        if (!_this.state.animating) {
          if (_this.props.onConfirm) {
            e.preventDefault();
            _this.props.onConfirm();
          }
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EnterpriseModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _get3.default)(EnterpriseModal.prototype.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseModal.prototype), 'componentDidMount', this).call(this);
      if (typeof document !== 'undefined' && this.props.keyboard) this.bindKeyboard();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _get3.default)(EnterpriseModal.prototype.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseModal.prototype), 'componentWillUnmount', this).call(this);
      if (typeof document !== 'undefined') this.unbindKeyboard();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      (0, _get3.default)(EnterpriseModal.prototype.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseModal.prototype), 'componentWillReceiveProps', this).call(this, nextProps);

      if (this.props.keyboard !== nextProps.keyboard) {
        if (nextProps.keyboard) {
          this.bindKeyboard();
        } else {
          this.unbindKeyboard();
        }
      }
    }
  }, {
    key: 'onToggle',
    value: function onToggle(state) {
      // Call super (calls props.onToggle)
      (0, _get3.default)(EnterpriseModal.prototype.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseModal.prototype), 'onToggle', this).call(this, state);

      if (typeof document !== 'undefined') {
        var container = document.body;

        // Increment modal count when opening.
        if (state) numberOfModalsOpen += 1;

        // Add toggle body class if there is only one modal open.
        if (numberOfModalsOpen === 1) {
          (0, _toggleClass2.default)(container, 'modal-open', state);
        }

        // Decrement modal count when closing.
        if (!state) {
          numberOfModalsOpen = Math.max(numberOfModalsOpen - 1, 0);
        }
      }
    }

    /* KEYBOARD
    * --------------------------------------------------------------------------------------------- */

  }, {
    key: 'bindKeyboard',
    value: function bindKeyboard() {
      // Ensure we don't bind twice
      this.unbindKeyboard();

      if (typeof document !== 'undefined') {
        this._keyHandler = this.handleKeys;
        document.addEventListener('keyup', this._keyHandler, false);
      }
    }
  }, {
    key: 'unbindKeyboard',
    value: function unbindKeyboard() {
      if (typeof document !== 'undefined') {
        if (this._keyHandler) {
          document.removeEventListener('keyup', this._keyHandler, false);
          this._keyHandler = null;
        }
      }
    }
  }]);
  return EnterpriseModal;
}(_Modal3.default), _class.propTypes = (0, _extends3.default)({}, _Modal3.default.propTypes, {
  keyboard: _react.PropTypes.bool
}), _class.defaultProps = (0, _extends3.default)({}, _Modal3.default.defaultProps, {
  keyboard: true
}), _temp2);
exports.default = EnterpriseModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseModal/EnterpriseModal.jsx
// module id = 347
// module chunks = 0